/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Inject, NgZone} from '@angular/core';
import template from './report-translation-edit-page.component.html';
import {AppEventBusService} from '../common/events/app-event-bus.service';

import {AdminResourceEditPageBase} from '../common/controller/admin-resource-edit-page-base';
import {LOCALES} from '../common/constants/locales';
import {
  buildReportTranslationOverrides,
  getActiveReportTranslationOverrides,
  initReportTranslationModel,
  prepareReportTranslationForSubmit,
  REPORT_TRANSLATION_LANGUAGES,
  ReportTranslationOverride,
  ReportTranslationOverrideMap
} from './report-translation-commons';
import {LocalNetworkProfile} from '../../components/session/local-network-profile';
import {ReportTranslationDefaultsResource} from '../../components/api/resources/resource/report-translation-defaults';
import {UserProfileSaverService} from '../../components/session/user-profile-saver.service';

@Component({
  standalone: false,
  selector: 'adn-report-translation-edit-page',
  template
})
export class ReportTranslationEditPageComponent extends AdminResourceEditPageBase {
  readonly locales = LOCALES;
  readonly languages = REPORT_TRANSLATION_LANGUAGES;

  translations: ReportTranslationOverrideMap = {};
  translationsLoaded = false;
  activeOverrides: ReportTranslationOverride[] = [];

  constructor(
    eventBus: AppEventBusService,
    @Inject(UserProfileSaverService) UserProfileSaver: any,
    @Inject(LocalNetworkProfile) LocalNetworkProfile: any,
    @Inject(ReportTranslationDefaultsResource) private reportTranslationDefaultsResource: any,
    ngZone: NgZone
  ) {
    super(eventBus, UserProfileSaver, LocalNetworkProfile, ngZone);
  }

  languageLabel(language: string): string {
    if (language === 'EN') {
      return 'English';
    }
    if (language === 'DE') {
      return 'German';
    }
    return 'French';
  }

  onDefaultTranslationChange(): void {
    this.syncActiveOverrides();
    this.markExternalFormDirty();
  }

  protected afterInitEditingModel(): void {
    initReportTranslationModel(this.editingModel);
    this.loadTranslationDefaults();
  }

  protected onBeforeSubmit(): void {
    prepareReportTranslationForSubmit(this.editingModel, this.translations);
  }

  private loadTranslationDefaults(): void {
    this.translationsLoaded = false;
    this.reportTranslationDefaultsResource.get().then((transDefaults: Record<string, Record<string, string>>) => {
      this.translations = buildReportTranslationOverrides(this.editingModel, transDefaults || {});
      this.syncActiveOverrides();
      this.translationsLoaded = true;
    });
  }

  private syncActiveOverrides(): void {
    this.activeOverrides = getActiveReportTranslationOverrides(this.translations, this.editingModel.defaultTranslation);
  }
}
